import React from 'react';
import { useNavigate } from 'react-router-dom';
import BottomNavigation from '../components/BottomNavigation';
import './Quizzes.css';

const Quizzes: React.FC = () => {
  const navigate = useNavigate();

  const quizzes = [
    { id: 1, title: 'Math Quiz 1', course: 'Advanced Mathematics', score: 85, date: '2024-01-15', status: 'Completed' },
    { id: 2, title: 'English Quiz', course: 'English Literature', score: null, date: '2024-01-20', status: 'Pending' },
    { id: 3, title: 'Science Test', course: 'Computer Science', score: 92, date: '2024-01-10', status: 'Completed' }
  ];

  return (
    <div className="quizzes-page">
      <header className="quizzes-header">
        <button className="back-button" onClick={() => navigate('/profile')}>
          ←
        </button>
        <h1>Quizzes</h1>
        <div className="header-spacer"></div>
      </header>

      <div className="quizzes-content">
        {quizzes.map((quiz) => (
          <div key={quiz.id} className="quiz-card">
            <div className="quiz-header">
              <div className="quiz-icon">📝</div>
              <div className="quiz-info">
                <h3 className="quiz-title">{quiz.title}</h3>
                <p className="quiz-course">{quiz.course}</p>
              </div>
              <span className={`quiz-status ${quiz.status.toLowerCase()}`}>
                {quiz.status}
              </span>
            </div>
            <div className="quiz-footer">
              <span className="quiz-date">Date: {quiz.date}</span>
              {quiz.score !== null ? (
                <span className="quiz-score">Score: {quiz.score}%</span>
              ) : (
                <button className="take-quiz-button">Take Quiz</button>
              )}
            </div>
          </div>
        ))}
      </div>

      <BottomNavigation />
    </div>
  );
};

export default Quizzes;

